<template>
  <div id="nbus_page">
    <section>

      <!-- ======================== 화면 가림 ======================== -->
      <div class="overlay" v-if="showOverlay">
        <div class="overlay-text">Coming Soon...</div>
      </div>

      <!-- ======================== 히어로 헤더 ======================== -->
      <div class="nbus-hero">
        <div class="hero-bg-circle c1"></div>
        <div class="hero-bg-circle c2"></div>
        <div class="hero-inner">
          <img src="../assets/img/nbus/nbus_trans.png" alt="엔버스로고" class="nbusLogo">
          <p class="nbusSlogan">손쉽고 빠른 일본 버스대절 서비스</p>
          <div class="hero-chips">
            <span class="hero-chip">🚐 전용 차량</span>
            <span class="hero-chip">🗺 맞춤 코스</span>
            <span class="hero-chip">👨‍✈️ 드라이빙 가이드</span>
          </div>
        </div>
      </div>

      <!-- ======================== 이용후기 ======================== -->
      <div class="review-section" v-if="this.reviewList.length > 0">
        <div class="container">
          <div class="section-label">⭐ 이용후기</div>
          <div v-if="this.reviewList.length > 0">
            <div class="review-item" :key="i" v-for="(rl, i) in this.reviewList">
              <div class="review-img-wrap">
                <img v-if="!rl.imgName || rl.iUseFlag == 'N'"
                     :src="`/download/noImage/noImage2.jpg`"
                     class="review-img" title="리뷰어의 이미지가 없습니다" />
                <img v-else
                     :src="`/download/review/${rl.revCode}/${rl.imgName}`"
                     class="review-img" />
              </div>
              <div class="review-content">
                <div class="review-title-wrap">
                  <span class="reviewt d-inline-block text-truncate" style="max-width:240px;"
                        v-if="rl.insId === this.user.email">
                    {{ rl.nTitle }}&nbsp;
                    <button type="button" class="btn-review-edit"
                            @click="changeReview(rl.revCode, rl.seqNotice, rl.seqImg)">수정</button>
                  </span>
                  <span class="reviewt d-inline-block text-truncate" style="max-width:240px;" v-else>
                    {{ rl.nTitle }}
                  </span>
                </div>
                <div class="reviewn">
                  <span class="review-name">{{ rl.rId.substring(0,3) }}○○○님</span>
                  <span class="review-date">{{ this.getDateFormat(rl.rDate) }}</span>
                </div>
                <pre class="reviewContent review-body">{{ rl.nContent }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ======================== 메인 폼 ======================== -->
      <div class="benefit mt-0">
        <div class="container">
          <div class="b-cont">
            <div class="row justify-content-center">
              <div class="col-12 col-lg-6 nBusDetail">

                <!-- STEP 1: 기본 정보 -->
                <div class="step-card">
                  <div class="step-header">
                    <span class="step-num">01</span>
                    <span class="step-title">여행 기본 정보</span>
                  </div>
                  <div class="step-body">
                    <div class="field-wrap">
                      <label class="field-label">탑승일</label>
                      <input type="date" class="nbus-input"
                             placeholder="시작일" v-model="rentStartDate"
                             ref="rentStartDate">
                    </div>
                    <div class="field-wrap">
                      <label class="field-label">사용일수</label>
                      <select v-model="rentTotDays" class="nbus-select">
                        <option v-for="i in 10" :key="i">{{ i }}</option>
                      </select>
                      <p class="field-hint">※ 1일(09:00 ~ 18:00) 기준입니다</p>
                    </div>
                    <div class="field-wrap">
                      <label class="field-label">탑승인원</label>
                      <input type="number" class="nbus-input text-end"
                             min="0" max="1000"
                             placeholder="미정인 경우 입력 불필요"
                             v-model="personCnt" ref="personCnt">
                    </div>
                  </div>
                </div>

                <!-- STEP 2: 일차별 일정 -->
                <div class="step-card">
                  <div class="step-header">
                    <span class="step-num">02</span>
                    <span class="step-title">일정 입력</span>
                  </div>
                  <div class="step-body">
                    <div class="day-block" :key="j" v-for="j in rentTotDays*1">
                      <div class="day-label">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                             fill="currentColor" class="bi bi-bus-front" viewBox="0 0 16 16">
                          <path d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm1-6c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9s3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44 44 0 0 0 8 4m0-1c-1.837 0-3.353.107-4.448.22a.5.5 0 1 1-.104-.994A44 44 0 0 1 8 2c1.876 0 3.426.109 4.552.226a.5.5 0 1 1-.104.994A43 43 0 0 0 8 3"/>
                          <path d="M15 8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1V2.64c0-1.188-.845-2.232-2.064-2.372A44 44 0 0 0 8 0C5.9 0 4.208.136 3.064.268 1.845.408 1 1.452 1 2.64V4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v3.5c0 .818.393 1.544 1 2v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14h6v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2c.607-.456 1-1.182 1-2zM8 1c2.056 0 3.71.134 4.822.261.676.078 1.178.66 1.178 1.379v8.86a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 11.5V2.64c0-.72.502-1.301 1.178-1.379A43 43 0 0 1 8 1"/>
                        </svg>
                        <span class="skdDay">{{ j }}일차</span>
                        <span class="same-check" v-if="j > 1">
                          동일한 일정
                          <input class="form-check-input ms-1" type="checkbox"
                                 :id="j" true-value="Y" false-value="N"
                                 @change="makeSame($event, j)">
                        </span>
                      </div>

                      <div class="route-inputs">
                        <input type="text" class="nbus-input route-input"
                               placeholder="📍 출발지" v-model="deptPoint[j]"
                               :ref="'deptPoint'+j">
                        <div class="route-arrow">↓</div>
                        <input type="text" class="nbus-input route-input"
                               placeholder="🔀 경유지 (선택)" v-model="viaPoint[j]"
                               :ref="'viaPoint'+j">
                        <p class="field-hint mt-1">※ 경유지 입력은 선택사항입니다</p>
                        <div class="route-arrow">↓</div>
                        <input type="text" class="nbus-input route-input"
                               placeholder="🏁 도착지" v-model="arrPoint[j]"
                               :ref="'arrPoint'+j">
                      </div>

                      <div class="time-row">
                        <div class="time-field">
                          <label class="field-label">시작시간</label>
                          <select v-model="rentStartTime[j]" class="nbus-select"
                                  :ref="'rentStartTime'+j">
                            <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
                          </select>
                        </div>
                        <div class="time-sep">~</div>
                        <div class="time-field">
                          <label class="field-label">종료시간</label>
                          <select v-model="rentCloseTime[j]" class="nbus-select"
                                  :ref="'rentCloseTime'+j">
                            <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="day-divider" v-if="j < rentTotDays*1"></div>
                    </div>
                  </div>
                </div>

                <!-- STEP 3: 기타 요청사항 -->
                <div class="step-card">
                  <div class="step-header">
                    <span class="step-num">03</span>
                    <span class="step-title">기타 요청사항</span>
                  </div>
                  <div class="step-body">
                    <textarea class="nbus-textarea" ref="etcInquiry"
                              v-model="etcInquiry" maxlength="200"
                              placeholder="기타 추가사항 (최대 200자)&#10;&#10;1. 일정관련 세부사항&#10;2. 이동경로 추가사항&#10;3. 기타사항 등"></textarea>
                  </div>
                </div>

                <!-- STEP 4: 차량 선택 -->
                <div class="step-card">
                  <div class="step-header">
                    <span class="step-num">04</span>
                    <span class="step-title">차량 선택</span>
                  </div>
                  <div class="step-body">
                    <div class="bus-grid">

                      <button class="bus-card"
                              :class="{ 'bus-selected': busFlag === 'luxB' }"
                              @click="choiceBus('luxB')" ref="busFlag">
                        <span class="bus-icon-wrap" style="position:relative">
                          <i class="bi bi-bus-front bus-icon"></i>
                          <!-- 10인승 버스 상세 레이어 -->
                          <span class="bus-info-trigger" @click.stop="showLayer_10p = !showLayer_10p">
                            <i class="bi bi-question-circle-fill fs-6 text-danger"></i>
                          </span>
                        </span>
                        <span class="bus-type-name">10인승 밴</span>
                        <span class="bus-type-cap">승객 9인</span>
                        <span class="bus-type-desc">프라이빗 투어 적합<br>한국인 드라이빙가이드 포함</span>
                        <!-- 버스 상세 레이어 -->
                        <div v-if="showLayer_10p" :style="layerStyle" @click.stop>
                          <div style="display:flex; flex-direction:column; align-items:flex-start; width:100%">
                            <div style="display:flex;">
                              <img src="../assets/img/nbus/nbus_10p.png" style="width:145px; height:130px;"/>
                              <img src="../assets/img/nbus/nbus_10pDetail.png" style="width:145px; height:130px;"/>
                            </div>
                            <span style="font-size:0.72rem; margin-top:8px; padding-left:8px; color:#ddd;">
                              ※ 이해를 위한 이미지이며, 실제 차량은 상이할 수 있습니다
                            </span>
                          </div>
                        </div>
                      </button>

                      <button class="bus-card"
                              :class="{ 'bus-selected': busFlag === 'micB' }"
                              @click="choiceBus('micB')">
                        <span class="bus-icon-wrap">
                          <i class="bi bi-bus-front bus-icon"></i>
                        </span>
                        <span class="bus-type-name">마이크로버스</span>
                        <span class="bus-type-cap">최대 16인승</span>
                        <span class="bus-type-desc">소규모 여행 시 적합</span>
                      </button>

                      <button class="bus-card"
                              :class="{ 'bus-selected': busFlag === 'midB' }"
                              @click="choiceBus('midB')">
                        <span class="bus-icon-wrap">
                          <i class="bi bi-bus-front bus-icon"></i>
                        </span>
                        <span class="bus-type-name">중형버스</span>
                        <span class="bus-type-cap">최대 26인승</span>
                        <span class="bus-type-desc">쾌적한 좌석으로 즐기는 여행</span>
                      </button>

                      <button class="bus-card"
                              :class="{ 'bus-selected': busFlag === 'lagB' }"
                              @click="choiceBus('lagB')">
                        <span class="bus-icon-wrap">
                          <i class="bi bi-bus-front bus-icon"></i>
                        </span>
                        <span class="bus-type-name">대형버스</span>
                        <span class="bus-type-cap">최대 49인승</span>
                        <span class="bus-type-desc">단체 여행에 최적화</span>
                      </button>

                    </div>

                    <!-- 가이드 선택 -->
                    <div class="guide-wrap">
                      <label class="guide-check-label">
                        <input class="form-check-input me-2" type="checkbox"
                               name="guideFlag" @change="needGuide($event)"
                               ref="guideFlag">
                        가이드가 필요해요
                      </label>
                    </div>

                    <div class="guide-type-wrap" v-if="this.nGuide === 'Y'">
                      <div class="guide-radio" :key="i" v-for="(gd, i) in guideInfo">
                        <label class="guide-radio-label">
                          <input class="form-check-input me-2" type="radio"
                                 name="guideFlag" v-model="guideFlag" :value="gd.baseCode">
                          <span class="guideType">{{ gd.codeNameKor }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- 안내사항 -->
                    <div class="bus-notice">
                      <p>🚌 모든 버스에는 운전기사가 배치됩니다.</p>
                      <p>⚠️ 버스 이용 시 운전기사(일본인)와 소통이 가능해야 하며, 불가능한 경우 인솔자 및 가이드가 필수로 포함되어야 합니다.</p>
                      <p>📞 견적 신청 후, 상세 일정 확인 및 이동동선 조율을 위해 담당자가 연락드릴 예정입니다.</p>
                    </div>

                  </div>
                </div>

                <!-- STEP 5: 연락처 -->
                <div class="step-card">
                  <div class="step-header">
                    <span class="step-num">05</span>
                    <span class="step-title">연락처 정보</span>
                  </div>
                  <div class="step-body">
                    <div class="field-wrap">
                      <label class="field-label">고객명</label>
                      <input type="text" class="nbus-input"
                             placeholder="성함을 입력해 주세요"
                             v-model="inqName" ref="inqName">
                    </div>
                    <div class="field-wrap">
                      <label class="field-label">휴대전화</label>
                      <input type="text" class="nbus-input"
                             placeholder="안내(카카오톡)를 받으실 모바일 연락처"
                             v-model="inqTel" ref="inqTel">
                    </div>
                  </div>
                </div>

                <!-- 신청 버튼 -->
                <button class="btn reqBtn" @click="inquiryNbus">
                  <i class="bi bi-send-fill me-2"></i>견 적 신 청 하 기
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 하단 이미지 -->
      <div class="join mt-5">
        <div class="container nbusBottom">
          <img src="../assets/img/nbus/nbusbottom.jpg" class="img-fluid fbus">
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {genCode} from '../assets/js/genCode';
import moment from 'moment';
import { handlerInfo } from '../assets/js/commonFunctions'

export default {
  data() {
    return {
      inqCode: "",
      inqName: "",
      inqId: "",
      inqTel: "",
      rentStartDate: "",
      rentCloseDate: "",
      rentStartTime: [],
      rentCloseTime: [],
      deptPoint: [],
      arrPoint: [],
      etcInquiry: "",
      guideFlag: "",
      personCnt: 0,
      busFlag: "",
      times: [],
      rentTotDays: 1,
      viaPoint: [],
      today: "",
      nGuide: "N",
      handTel: [],
      handTelCnt: 0,
      memFlag: "",
      guideInfo: [],
      busInfo: [],
      reviewList: [],
      showOverlay: false,
      showLayer_10p: false,
    }
  },
  created() {
    this.user = this.$store.state.user;
    if(!this.user.email)
    {
      this.memFlag = "N"
    }
    else
    {
      this.memFlag = "Y"
      this.inqId = this.user.email;
      if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.user.joinFlag === "H" || this.user.joinFlag === "M")
      {
        this.k_name = (!this.user.nickname) ? "" : this.user.nickname;
        let kakaoPhone = ""
        if(this.user.alimCallC != undefined && this.user.alimCallC.charAt(0) === '+')
        {
          kakaoPhone = this.user.alimCallC.replace("+82 ", "0")
        }
        else
        {
          kakaoPhone = this.user.alimCallC
        }
        this.k_tel = (!this.user.alimCallC) ? "" : kakaoPhone.replace(/-/g,"");
      }
      else
      {
        this.k_name = this.user.name;
        this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,"");
      }
      this.inqName = this.k_name
      this.inqTel = this.k_tel
    }
    this.getGuideInfo()
    this.getBusInfo()
    this.getHandlerInfo()
    this.getReviewList()
    document.oncontextmenu = function() { return false; }
    document.ondragstart = function() { return false; }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    layerStyle() {
      return {
        position: 'absolute',
        top: '70px',
        left: '25px',
        width: '300px',
        height: '190px',
        background: 'rgba(0,0,0,0.75)',
        borderRadius: '10px',
        zIndex: 10,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }
  },
  mounted(){
    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")
    this.generateTimeOptions();
  },
  methods: {
    getDateFormat(date) { return this.$dateFormat(date); },
    changeReview(rvCode, nSeq, iSeq) {
      this.$router.push({path: '/reviewModify', query: {rvCode: rvCode, nSeq: nSeq, iSeq: iSeq}});
    },
    generateTimeOptions() {
      const times = [];
      const startTime = new Date();
      startTime.setHours(0);
      startTime.setMinutes(0);
      for (let i = 0; i < 48; i++) {
        times.push(this.formatTime(startTime));
        startTime.setMinutes(startTime.getMinutes() + 30);
      }
      this.times = times;
    },
    formatTime(time) {
      const hours = time.getHours().toString().padStart(2, '0');
      const minutes = time.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    async getReviewList() {
      let reviewList = await this.$api("/api/reviewList_nbus", {});
      if(reviewList.length > 0) { this.reviewList = reviewList }
    },
    async getGuideInfo(){
      let guideInfo = await this.$api("/api/searchBasecode_more", { param: [ "guideLv", "guCd", "Y"] });
      if(guideInfo.length > 0) { this.guideInfo = guideInfo }
    },
    async getBusInfo(){
      let busInfo = await this.$api("/api/searchBasecode_more", { param: [ "rentBus", "buCd", "Y"] });
      if(busInfo.length > 0) { this.busInfo = busInfo }
    },
    makeSame(e, j){
      let isChecked = e.target.checked
      if(isChecked === true)
      {
        this.deptPoint[j] = this.deptPoint[1]
        this.viaPoint[j] = this.viaPoint[1]
        this.arrPoint[j] = this.arrPoint[1]
        this.rentStartTime[j] = this.rentStartTime[1]
        this.rentCloseTime[j] = this.rentCloseTime[1]
      }
      else
      {
        this.deptPoint[j] = ""
        this.viaPoint[j]  = ""
        this.arrPoint[j]  = ""
        this.rentStartTime[j] = ""
        this.rentCloseTime[j] = ""
      }
    },
    needGuide(event){
      let isChecked = event.target.checked
      if(isChecked === true) { this.nGuide = "Y"; this.guideFlag = "GG" }
      else { this.nGuide = "N"; this.guideFlag = "" }
    },
    choiceBus(bFlag){ this.busFlag = bFlag },
    async genCode(param) {
      let chkFlag = "N";
      let rtnCode = "";
      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++)
      {
        let ymd = this.today.replace(/-/g, '')
        let dCd = param + ymd;
        rtnCode = await genCode(this.$api, dCd);
        let chk_genCode = await this.$api("/api/checkDub_resCode", { param: [rtnCode] });
        if (chk_genCode.length > 0) { chkFlag = "N"; } else { chkFlag = "Y"; }
      }
      if (chkFlag === "N")
      {
        this.$swal.fire("","예약번호 생성횟수 한계에 도달하였습니다.<br>담당자에게 문의(1660-4602)하여 주세요.","warning")
        return false;
      }
      else { return rtnCode }
    },
    async getManagerList()
    {
      let chargePList = await this.$api("/api/handlerInfo", {})
      if(chargePList.length > 0) { this.chargePList = chargePList; }
    },
    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0) { this.handTel = handTel }
    },
    async inquiryNbus(){
      if(!this.rentStartDate)
      {
        this.$refs.rentStartDate.focus();
        this.$swal.fire("","이용일자를 입력하세요", "warning")
        return false;
      }
      else
      {
        if(this.rentStartDate <= this.today)
        {
          this.$refs.rentStartDate.focus();
          this.$swal.fire("","이전일 또는 당일예약은 진행하실 수 없습니다.", "warning")
          return false;
        }
      }
      let j = 1
      while(j <= this.rentTotDays*1)
      {
        if(!this.deptPoint[j]) { this.$refs['deptPoint'+j][0].focus(); this.$swal.fire("","출발지를 입력하세요", "warning"); return false; }
        if(!this.arrPoint[j]) { this.$refs['arrPoint'+j][0].focus(); this.$swal.fire("","도착지를 입력하세요", "warning"); return false; }
        if(!this.rentStartTime[j]) { this.$refs['rentStartTime'+j][0].focus(); this.$swal.fire("","출발시간을 입력하세요", "warning"); return false; }
        if(!this.rentCloseTime[j]) { this.$refs['rentCloseTime'+j][0].focus(); this.$swal.fire("","종료시간을 입력하세요", "warning"); return false; }
        j++
      }
      if(!this.busFlag) { this.$refs.busFlag.focus(); this.$swal.fire("","탑승할 버스를 선택해주세요", "warning"); return false; }
      if(!this.inqName) { this.$refs.inqName.focus(); this.$swal.fire("","고객성함을 입력해주세요", "warning"); return false; }
      if(!this.inqTel) { this.$refs.inqTel.focus(); this.$swal.fire("","연락받으실 휴대전화번호를 입력해주세요", "warning"); return false; }
      let catCode = "NB-";
      let inqCode = await this.genCode(catCode)
      this.inqCode = inqCode
      let useFlag = "Y"
      let inqEmail = ""
      let insId = this.inqId
      let inqStatus = "IQ"
      let checkFlag = "N"
      let insNbusInquiry = await this.$api("/api/insNbusInquiry", {param: [
        this.inqCode, this.inqName, this.inqId, this.inqTel, inqEmail, this.rentStartDate, this.guideFlag, this.personCnt, this.busFlag, insId, useFlag, inqStatus, checkFlag, this.rentTotDays, this.etcInquiry, this.memFlag, this.user.memLevel
      ]});
      if(insNbusInquiry.affectedRows < 0)
      {
        this.$swal.fire("", "문의등록 중 오류가 발생했습니다<br>재시도를 해주십시오", "warning")
        return false;
      }
      else
      {
        let promises = []
        let i = 1
        while(i <= this.rentTotDays*1)
        {
          let insNbusInquiry_detail = await this.$api("/api/insNbusInquiry_detail", {param: [
            this.inqCode, i, this.rentStartTime[i], this.rentCloseTime[i], this.deptPoint[i], this.viaPoint[i], this.arrPoint[i], "Y"
          ]});
          promises.push(insNbusInquiry_detail)
          i++
        }
        Promise.all(promises).then(() => {
          this.sendKakao(this.inqCode, "nbRes")
        })
      }
    },
    async sendKakao(nbCode, param){
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [ nbCode, param, this.inqTel ]});
      let guide = ""
      if(this.nGuide === "Y")
      {
        let guide_tmp = this.guideInfo.filter((item) => { return item.baseCode === this.guideFlag })
        guide = guide_tmp[0].codeNameKor
      }
      else { guide = "없음" }
      let bus = ""
      let bus_tmp = this.busInfo.filter((item) => { return item.baseCode === this.busFlag })
      bus = bus_tmp[0].codeNameKor + "("+bus_tmp[0].spRemark+")"
      this.handTel.push({aimCall: this.inqTel})
      this.handTelCnt = this.handTel.length
      if(insKSendHistory.affectedRows > 0)
      {
        let promises = []
        if(param == "nbRes")
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            let kakaoAlimData = {
              inqName: this.inqName,
              inqTel: this.inqTel,
              paxCnt: this.personCnt,
              guideLv: guide,
              busLv: bus,
              deptPoint: this.deptPoint[1],
              rentStartDate: this.rentStartDate,
              rentStartTime: this.rentStartTime[1],
              rentTotDays: this.rentTotDays,
              inqCode: nbCode,
              alimFlag: param,
              memFlag: this.memFlag,
              pdtCode: nbCode,
              clientCall: this.handTel[i].aimCall,
            };
            let promise = this.$api("api/kakaoAlimSend7", { param: [{ kakaoAlimData: kakaoAlimData}] })
            promises.push(promise)
            i++
          }
          Promise.all(promises).then(() => {
            this.$swal.fire('', '엔버스접수 알림톡이 발송되었습니다', 'success').then(() => {
              this.$router.push({ path: "/" })
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Noto+Sans+KR:wght@400;500;600;700&display=swap');

/* ================================================
  # CSS 변수 — #nbus_page 하위
================================================ */
#nbus_page {
  --nbus-green:       #51CE9B;
  --nbus-green-dark:  #35b07f;
  --nbus-green-light: #e0f9ef;
  --nbus-navy:        #1a2f3c;
  --off-white:        #f7f9f8;
  --gray-50:          #f4f6f5;
  --gray-100:         #eaeeed;
  --gray-200:         #d5ddd9;
  --gray-400:         #8fa49b;
  --gray-600:         #556660;
  --text-main:        #1a2f3c;
  --text-sub:         #556660;
  --radius-sm:        8px;
  --radius-md:        16px;
  --radius-lg:        24px;
  --shadow-sm:        0 2px 12px rgba(26,47,60,0.08);
  --shadow-md:        0 8px 28px rgba(26,47,60,0.13);

  margin-top: -3.5rem;
  background: var(--off-white);
  font-family: 'Noto Sans KR', sans-serif;
}

@media (max-width: 992px) {
  #nbus_page { margin-top: 2.2rem; }
}


/* ================================================
  # 화면 가림
================================================ */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.overlay-text {
  color: #fff;
  font-size: 5rem;
  font-weight: 900;
  font-family: 'Black Han Sans', sans-serif;
}
@media (max-width: 500px) {
  .overlay-text { font-size: 2.5rem; }
}


/* ================================================
  # 히어로
================================================ */
.nbus-hero {
  position: relative;
  width: 100%;
  background: var(--nbus-navy);
  padding: 5rem 1.5rem 3.5rem;
  text-align: center;
  overflow: hidden;
  display: block;
}
.hero-bg-circle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.hero-bg-circle.c1 {
  width: 300px; height: 300px;
  background: rgba(81,206,155,0.12);
  top: -80px; left: -60px;
}
.hero-bg-circle.c2 {
  width: 200px; height: 200px;
  background: rgba(81,206,155,0.08);
  bottom: -50px; right: -30px;
}
.hero-inner { position: relative; z-index: 1; }

.nbusLogo { width: 180px; margin-bottom: 0.6rem; }
.nbusSlogan {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgba(255,255,255,0.85);
  margin-bottom: 1.5rem;
}
.hero-chips {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
.hero-chip {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--nbus-navy);
  background: var(--nbus-green);
  border-radius: 20px;
  padding: 5px 14px;
}

@media (max-width: 500px) {
  .nbusLogo { width: 140px; }
  .nbusSlogan { font-size: 0.95rem; }
  .nbus-hero { padding: 5rem 1rem 3rem; }
}


/* ================================================
  # 이용후기
================================================ */
.review-section {
  background: #fff;
  padding: 2rem 0;
  border-bottom: 1px solid var(--gray-100);
}
.section-label {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--nbus-green-dark);
  margin-bottom: 1.2rem;
}
.review-item {
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--gray-100);
  align-items: flex-start;
}
.review-item:last-child { border-bottom: none; }
.review-img-wrap { flex-shrink: 0; }
.review-img { width: 100px; height: 80px; object-fit: cover; border-radius: var(--radius-sm); }
.review-content { flex: 1; }
.reviewt { font-size: 0.95rem; font-weight: 700; color: var(--text-main); }
.btn-review-edit {
  font-size: 0.7rem;
  border: 1px solid var(--gray-400);
  background: none;
  border-radius: 4px;
  padding: 1px 6px;
  color: var(--gray-600);
  cursor: pointer;
  margin-left: 5px;
}
.reviewn {
  font-size: 0.75rem;
  color: var(--gray-400);
  margin: 3px 0 6px;
  display: flex;
  gap: 8px;
}
.review-body {
  font-size: 0.85rem;
  color: var(--text-sub);
  word-wrap: break-word;
  white-space: pre-wrap;
  margin: 0;
}


/* ================================================
  # 폼 섹션 공통
================================================ */
.benefit {
  padding: 2rem 0 4rem;
}
/* benefit 안의 container만 padding 적용 */
.benefit .container { padding: 16px; }

/* 스텝 카드 */
.step-card {
  background: #fff;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 1.2rem;
  overflow: hidden;
  border: 1px solid var(--gray-100);
}
.step-header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.4rem;
  background: var(--gray-50);
  border-bottom: 1px solid var(--gray-100);
}
.step-num {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 1.1rem;
  color: var(--nbus-green);
  letter-spacing: 0;
  line-height: 1;
}
.step-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-main);
}
.step-body {
  padding: 1.4rem;
}


/* ================================================
  # 입력 필드 공통
================================================ */
.field-wrap { margin-bottom: 1rem; }
.field-wrap:last-child { margin-bottom: 0; }
.field-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--gray-600);
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}
.field-hint {
  font-size: 0.75rem;
  color: var(--gray-400);
  margin: 5px 0 0;
}

.nbus-input {
  width: 100%;
  border: 1.5px solid var(--gray-200);
  border-radius: var(--radius-sm);
  padding: 11px 14px;
  font-size: 0.9rem;
  color: var(--text-main);
  background: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-family: 'Noto Sans KR', sans-serif;
}
.nbus-input:focus {
  border-color: var(--nbus-green);
  box-shadow: 0 0 0 3px rgba(81,206,155,0.15);
}
.nbus-input::placeholder { color: var(--gray-400); }

.nbus-select {
  width: 100%;
  border: 1.5px solid var(--gray-200);
  border-radius: var(--radius-sm);
  padding: 11px 14px;
  font-size: 0.9rem;
  color: var(--text-main);
  background: url('../assets/img/icons/arrow_bottom.png') no-repeat right 14px center;
  background-size: 14px;
  background-color: #fff;
  appearance: none;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  cursor: pointer;
}
.nbus-select:focus {
  border-color: var(--nbus-green);
  box-shadow: 0 0 0 3px rgba(81,206,155,0.15);
}

.nbus-textarea {
  width: 100%;
  border: 1.5px solid var(--gray-200);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  font-size: 0.88rem;
  color: var(--text-main);
  min-height: 140px;
  resize: vertical;
  outline: none;
  font-family: 'Noto Sans KR', sans-serif;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.nbus-textarea:focus {
  border-color: var(--nbus-green);
  box-shadow: 0 0 0 3px rgba(81,206,155,0.15);
}
.nbus-textarea::placeholder { color: var(--gray-400); }

/* form-check-input 커스텀 */
.form-check-input:checked {
  background-color: var(--nbus-green);
  border-color: var(--nbus-green);
}
.form-check-input:focus {
  border-color: var(--nbus-green);
  box-shadow: 0 0 0 3px rgba(81,206,155,0.2);
}


/* ================================================
  # 일차별 일정
================================================ */
.day-block { margin-bottom: 0.8rem; }
.day-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.8rem;
}
.day-label .bi { color: var(--nbus-green); }
.skdDay { font-weight: 700; }
.same-check {
  font-size: 0.78rem;
  font-weight: 400;
  color: var(--gray-600);
  margin-left: auto;
  display: flex;
  align-items: center;
}

.route-inputs { display: flex; flex-direction: column; gap: 2px; }
.route-input { }
.route-arrow {
  text-align: center;
  color: var(--nbus-green);
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.8;
}

.time-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-top: 1rem;
}
.time-field { flex: 1; }
.time-sep {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--gray-400);
  padding-bottom: 10px;
}
.day-divider {
  border-top: 1px dashed var(--gray-200);
  margin: 1.2rem 0;
}


/* ================================================
  # 차량 선택
================================================ */
.bus-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 1.5rem;
}
.bus-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1rem 0.5rem;
  background: var(--gray-50);
  border: 2px solid var(--gray-200);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}
.bus-card:hover {
  border-color: var(--nbus-green);
  background: var(--nbus-green-light);
}
.bus-selected {
  background: var(--nbus-green) !important;
  border-color: var(--nbus-green-dark) !important;
  box-shadow: 0 4px 16px rgba(81,206,155,0.35);
}
.bus-icon-wrap {
  position: relative;
  display: block;
  margin-bottom: 4px;
}
.bus-icon {
  font-size: 1.8rem;
  color: var(--nbus-green-dark);
}
.bus-selected .bus-icon { color: #fff; }
.bus-info-trigger {
  position: absolute;
  top: -6px;
  right: -14px;
  font-size: 0.75rem;
  color: var(--gray-400);
  cursor: pointer;
}
.bus-selected .bus-info-trigger { color: rgba(255,255,255,0.7); }
.bus-type-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-main);
}
.bus-selected .bus-type-name { color: #fff; }
.bus-type-cap {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--nbus-green-dark);
  background: rgba(81,206,155,0.15);
  border-radius: 10px;
  padding: 2px 8px;
}
.bus-selected .bus-type-cap {
  background: rgba(255,255,255,0.25);
  color: #fff;
}
.bus-type-desc {
  font-size: 0.7rem;
  color: var(--gray-600);
  line-height: 1.3;
}
.bus-selected .bus-type-desc { color: rgba(255,255,255,0.85); }

/* 가이드 */
.guide-wrap {
  padding: 1rem;
  background: var(--gray-50);
  border-radius: var(--radius-sm);
  margin-bottom: 0.8rem;
}
.guide-check-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-main);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.guide-type-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0.8rem 1rem;
  background: var(--nbus-green-light);
  border-radius: var(--radius-sm);
  margin-bottom: 0.8rem;
}
.guide-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.guideType { font-size: 0.9rem; font-weight: 600; color: var(--text-main); }

/* 안내사항 */
.bus-notice {
  background: var(--gray-50);
  border-left: 3px solid var(--nbus-green);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  padding: 0.9rem 1rem;
  margin-top: 0.8rem;
}
.bus-notice p {
  font-size: 0.78rem;
  color: var(--text-sub);
  margin: 0 0 6px;
  line-height: 1.5;
}
.bus-notice p:last-child { margin-bottom: 0; }


/* ================================================
  # 신청 버튼
================================================ */
.btn.reqBtn {
  width: 100%;
  background: var(--nbus-green);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 900;
  padding: 16px;
  border-radius: var(--radius-md);
  border: none;
  letter-spacing: 3px;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
  transition: all 0.25s ease;
  box-shadow: 0 6px 20px rgba(81,206,155,0.35);
  font-family: 'Black Han Sans', sans-serif;
}
.btn.reqBtn:hover {
  background: var(--nbus-green-dark);
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(81,206,155,0.45);
}

@media (max-width: 500px) {
  .btn.reqBtn { font-size: 1rem; letter-spacing: 2px; }
}


/* ================================================
  # 하단 이미지
================================================ */
.join { margin: 2rem 0 0; }
.container.nbusBottom {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
}
.join .fbus {
  width: 100%;
  height: 28vh;
  object-fit: cover;
  display: block;
}
</style>